import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { LuBell, LuBookOpen, LuMail, LuUsers } from 'react-icons/lu';
import AuthContext from '../components/shared/AuthContext';
import PageMeta from '../components/seo/PageMeta';
import BackNav from '../components/navigation/BackNav';
import { useNotifications } from '../context/NotificationContext';
import '../components/notifications/notifications.css';

function TypeIcon({ type }) {
  const t = (type || '').toUpperCase();
  if (t.includes('TEAM') || t.includes('WORKSPACE')) return <LuUsers aria-hidden />;
  if (t.includes('NOTEBOOK') || t.includes('SHARE')) return <LuMail aria-hidden />;
  if (t.includes('LEARN') || t.includes('IMPORT')) return <LuBookOpen aria-hidden />;
  return <LuBell aria-hidden />;
}

function formatWhen(iso) {
  if (!iso) return '';
  try {
    return new Date(iso).toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' });
  } catch {
    return '';
  }
}

export default function NotificationsPage() {
  const { userProfile } = useContext(AuthContext);
  const { items, loading, unreadCount, markRead, markAllRead, refresh } = useNotifications();
  const navigate = useNavigate();

  const openItem = async (item) => {
    if (!item.read && item.id) {
      try {
        await markRead(item.id);
      } catch {
        /* ignore */
      }
    }
    if (item.linkPath) navigate(item.linkPath);
  };

  return (
    <>
      <PageMeta title="Notifications" description="Your QnaRead notifications" />
      <div className="home-minimal-wrap">
        <BackNav to="/dashboard" label="Study hub" />
        <div className="notifications-page">
          <header className="notifications-page-head">
            <div>
              <h1 className="notifications-page-title">Notifications</h1>
              <p className="notifications-page-sub">
                {unreadCount > 0 ? `${unreadCount} unread` : 'All caught up'}
                {userProfile?.email ? ` · ${userProfile.email}` : ''}
              </p>
            </div>
            {unreadCount > 0 && (
              <button type="button" className="home-btn home-btn-secondary" onClick={markAllRead}>
                Mark all read
              </button>
            )}
          </header>

          {loading && items.length === 0 && (
            <p className="notifications-page-sub">Loading…</p>
          )}

          {!loading && items.length === 0 && (
            <p className="notifications-page-sub">No notifications yet.</p>
          )}

          <div className="notifications-page-list">
            {items.map((item) => (
              <button
                key={item.id}
                type="button"
                className={`notifications-page-item${item.read ? '' : ' is-unread'}`}
                onClick={() => openItem(item)}
              >
                <span className="app-notifications-item-icon">
                  <TypeIcon type={item.type} />
                </span>
                <span className="app-notifications-item-body">
                  <span className="app-notifications-item-title">{item.title}</span>
                  {item.body && (
                    <span className="app-notifications-item-text">{item.body}</span>
                  )}
                  <span className="app-notifications-item-time">{formatWhen(item.createdAt)}</span>
                </span>
              </button>
            ))}
          </div>

          <p className="notifications-page-sub" style={{ marginTop: 16 }}>
            <button type="button" className="home-btn home-btn-secondary" onClick={refresh}>
              Refresh
            </button>
          </p>
        </div>
      </div>
    </>
  );
}
